import { z } from "zod";
export const horizonVersionFarmsAggregationDtoSchema = z.object({
    latestHorizonVersion: z.string().min(1),
    totalFarmCount: z.number().int().nonnegative(),
    outdatedHorizonVersionFarmPercentage: z.number().nonnegative(),
    transitionHorizonVersionFarmCount: z.number().nonnegative(),
});
//# sourceMappingURL=horizon-version-farms-aggregation.schema.js.map